import React from 'react';
import { FetchAssetOptions } from '../../../queries/ats/titles/api';
import { Asset } from '../../../queries/ats/titles/types/asset';
import { DetailsRootErrorBoundary } from '../details-error/details-error';
import { DetailsParams } from '../utils';
import { DefaultDetailsViewLoader } from './default-details-view-loader';
import { ProgramDetailsViewLoader } from './program-details-view-loader';
import { RecordingDetailsViewLoader } from './recording-details-view-loader';

export interface DetailsViewLoaderProps extends FetchAssetOptions {
  id: string;
  type: DetailsParams['type'];
  before?: ((title: Asset | undefined) => JSX.Element) | JSX.Element;
  after?: ((title: Asset | undefined) => JSX.Element) | JSX.Element;
}

/**
 * Fetches the title and displays a spinner while loading. Once the title
 * is fetched, the `DetailsView` is rendered.
 *
 * @param id The id of the title to fetch.
 * @param before An optional render prop that is rendered before the `DetailsView`.
 * @param after An optional render prop that is rendered after the `DetailsView`.
 */
export function DetailsViewLoader({ type, ...rest }: DetailsViewLoaderProps) {
  switch (type) {
    case 'recording':
      return (
        <DetailsRootErrorBoundary>
          <RecordingDetailsViewLoader {...rest} />
        </DetailsRootErrorBoundary>
      );
    case 'program':
      return (
        <DetailsRootErrorBoundary>
          <ProgramDetailsViewLoader {...rest} />
        </DetailsRootErrorBoundary>
      );
    default:
      return (
        <DetailsRootErrorBoundary>
          <DefaultDetailsViewLoader {...rest} />
        </DetailsRootErrorBoundary>
      );
  }
}
